const select =
  'id,sequenceId,pattern,automaticNumbersCurrentYear,automaticNumbersCurrentMonth,automaticNumbersCurrentDay,lastGeneratedNumber,rowVersion';

export default {
  paged: {
    select,
    searchSelect: ['pattern'],
    notSelectSearch: 'id,sequenceId',
  },
  detail: {
    select: `${select},creator,modifier,created,updated`,
  },
};
